import Vue from "vue";
import unauthorizedAccessMixin from "@/mixins/unauthorizedAccessMixin";
export default Vue.extend({
    mixins: [unauthorizedAccessMixin]
});
